<script>
import TaskValue from "@/views/pages/tasks/components/TaskValue.vue";

export default {
  name: "TasksListGroupItem",
  components: { TaskValue },

  props: {
    /** @type {TaskScheduledEvent} row */
    row: {
      type: Object,
      required: true,
    },
    /** @type {number} groupIdx */
    groupIdx: {
      type: Number,
      required: true,
    },
    /** @type {number} itemIdx */
    itemIdx: {
      type: Number,
      required: true,
    },
    /** @type {number} tableValuesColumnsLength */
    tableValuesColumnsLength: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    dateTimes() {
      if (!this.row.datetimes) {
        return [];
      }

      try {
        return Array.isArray(this.row.datetimes) ? this.row.datetimes : [];
      } catch (e) {
        console.error(e);
      }

      return [];
    },

    isDateTimesNotEmpty() {
      return this.dateTimes.length > 0;
    },
  },

  watch: {},

  // async created() {},
  //
  // async destroyed() {},

  methods: {},
};
</script>

<template>
  <tr :key="`${groupIdx}-${itemIdx}`" :class="{ 'task-close': row.finished }" @click.prevent="$emit('task-show', row)">
    <td>
      <div :class="{ 'text-decoration-line-through': row.finished }">{{ row.name }}</div>

      <div class="d-flex mt-1">
        <v-chip v-if="row.finished" x-small>Задание на паузе</v-chip>
        <v-chip v-if="row.diseases" x-small>{{ row.diseases.name }}</v-chip>
      </div>
    </td>

    <td>{{ row.periodicity ? row.periodicity.name : "-" }}</td>
    <td>
      <div v-if="isDateTimesNotEmpty">
        <div v-for="(dt, dtIdx) in dateTimes" :key="dtIdx">
          {{ $date(dt).format("DD.MM.YYYY") }}
        </div>
      </div>
      <span v-else>
        {{ $date(row.startAt).format("DD.MM.YYYY") }}
      </span>
    </td>
    <td>
      <span v-if="!isDateTimesNotEmpty">{{ row.endAt ? $date(row.endAt).format("DD.MM.YYYY") : "" }}</span>
    </td>

    <td width="30px"></td>

    <td class="text-center" v-for="(td, key) in row.list" :key="`${groupIdx}-${itemIdx}-${key}`">
      <TaskValue :data="td" />
    </td>
    <template v-if="!row.list.length">
      <td v-for="(_, noopIdx) in [].constructor(tableValuesColumnsLength)" :key="`${groupIdx}-${itemIdx}-${noopIdx}`"></td>
    </template>

    <td width="30px"></td>
    <td width="90px" class="text-right">
      <v-btn title="Редактировать" icon small text @click.stop="$emit('task-edit', row)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn v-if="!row.finished" title="Остановить задание" icon small text @click.stop="$emit('task-to-pause', row)">
        <v-icon>pause_circle_outline</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<style lang="scss" scoped></style>
